import React from 'react';
import { Tag } from '../../types';

interface TagBadgeProps {
  tag: Tag;
  onRemove?: () => void;
}

/**
 * Read-only pill rendering for a Tag. Uses the tag's color when set,
 * otherwise falls back to a neutral pill. Optional `onRemove` shows an
 * inline ✕ button — used by the Tag management UI.
 */
const TagBadge: React.FC<TagBadgeProps> = ({ tag, onRemove }) => {
  const styled = tag.color
    ? {
        backgroundColor: tag.color + '20',
        borderColor: tag.color,
        color: tag.color,
      }
    : {
        backgroundColor: 'var(--color-neutral-100)',
        borderColor: 'var(--color-neutral-200)',
        color: 'var(--color-neutral-700)',
      };

  return (
    <span
      className="inline-flex items-center gap-1 h-5 px-1.5 rounded text-[10px] font-medium border"
      style={styled}
    >
      {tag.name}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="opacity-60 hover:opacity-100"
          aria-label={`Remove ${tag.name}`}
        >
          <svg className="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </span>
  );
};

export default TagBadge;
